import { useMemo } from "react";

export const BACKGROUND_IMAGE = {
  id: "main-background",
  url: "https://res.cloudinary.com/dv9u0wicr/image/upload/v1745679682/oosjbratxuyaabeczvgv.png",
  priority: "high" as const,
  crossOrigin: "anonymous" as const,
};

export const FALLBACK_COLOR = "#000000";

export const useBackgroundImages = () => {
  return useMemo(() => [BACKGROUND_IMAGE], []);
};
